import { MaterialIconName } from '@gorila-shared-ui/components';
import { Item } from 'baseui/side-navigation';
import { SortDirection } from 'baseui/table';
import { ORDER_ASCENDING, ORDER_DESCENDING } from '../constants/app';
import { ON_ROUTE_STATUS, SEPARATION_STATUS } from '../constants/evaluations';
import {
  DRAW_MODE_CIRCLE,
  DRAW_MODE_POLYGON,
  DRAW_MODE_RECTANGLE,
  ROAD_MAP_TYPE,
  SATELLITE_MAP_TYPE,
} from '../constants/map';

export interface Page {
  id: string;
  icon?: MaterialIconName;
  name: string;
  route: string;
  permissionName: PagePermissionName;
  navKey?: string;
  pageTitle?: string;
}

export enum PagePermissionName {
  commands = 'commands',
  dashboard = 'dashboard',
  geofence = 'geofence',
  groups = 'groups',
  journeys = 'journeys',
  reports = 'reports',
  settings = 'settings',
  convoy = 'convoy',
  links = 'links',
  none = 'none',
  controlTower = 'controlTower',
  myFleet = 'myFleet',
}

export type MapType = typeof ROAD_MAP_TYPE | typeof SATELLITE_MAP_TYPE;

export type MapPointerInfo = {
  properties: { [key: string]: any };
  x: number;
  y: number;
};

export type MapDrawMode = typeof DRAW_MODE_POLYGON | typeof DRAW_MODE_CIRCLE | typeof DRAW_MODE_RECTANGLE;

export type MapDrawControlMode = typeof DRAW_MODE_POLYGON;
export const MapDrawControlModes = [DRAW_MODE_POLYGON] as const;

export type EvaluationStatus = typeof ON_ROUTE_STATUS | typeof SEPARATION_STATUS;

export interface SlugName {
  slug: string;
  name: string;
}

export interface IdName {
  _id: string;
  name: string;
}

export type SidenavBlock =
  | {
      type: 'flat';
      items: Item[];
    }
  | {
      type: 'section';
      id: string;
      title: string;
      items: Item[];
    };

export type PaginatedColumn = {
  key: string;
  label: string;
  minWidth?: number;
  maxWidth?: number;
  flex?: number;
  centered?: boolean;
  sortDirection?: SortDirection;
  sorteable?: boolean;
};

export type OrderDirection = typeof ORDER_ASCENDING | typeof ORDER_DESCENDING;

export interface FileDisplay {
  key: string;
  url: string;
}

export enum PaymentMethod {
  debit = 1,
  credit,
  cash,
  vouchers,
}

export enum ShareLinkDuration {
  fourHours = 4,
  eightHours = 8,
  twelveHours = 12,
  twentyFourHours = 24,
  fourtyEigthHours = 48,
  ninetySixHours = 96,
}

export enum RightCard {
  streaming,
  playback,
}

export enum BottomCard {
  pathInfo,
  replayControls,
}
